"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.noop = void 0;
require("../../core");
// eslint-disable-next-line @typescript-eslint/no-empty-function,@typescript-eslint/no-unused-vars
const noop = (...args) => { };
exports.noop = noop;
//# sourceMappingURL=noop.js.map